export var EmployerReviewRoutes = {
    "/review-documents/:doc_code/:doc_id": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.harriSH.review-documents",
        "type": "frontend",
        "component": "reviewDocumentsPage",
        "params": {
            prevState: null,
            prospect_id: null,
            app_id: null,
            showOBDocumentsModal: null,
            custom_type_name: null,
            custom_type_id: null
        },
        route_styles: {
            framework: "bootstrap_v4",
            styles: ["review_documents"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./employer-review.module.js");
                }
            }
        ],
        "onExit": ['localize', function (localize) {
            localize.enableLocale();
        }],
        "onEnter": ['localize', function (localize) {
            $('body').removeClass('modal-open');
            localize.disableLocale();
        }]
    }
};